import angular from 'angular';

import TripWireService from './TripWireService';
import TripWireComponent from './TripWireComponent';
import TripWireModalController from './TripWireModalController';
import './TripWireComponent.scss';

export default angular
  .module('petroCloud.tripwirePanel', [
    'ngSails',
    'ui.bootstrap'
  ])
  .service('TripWireService', TripWireService)
  .controller('TripWireModalController', TripWireModalController)
  .component(TripWireComponent.name, TripWireComponent)
  .name;
